import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/Board/labels/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_COLOR = NAMESPACE + 'SET_COLOR'
export const SET_POSITION = NAMESPACE + 'SET_POSITION'

const defaultBoardState = {
  labels: [],
}

const initialState = {
  labelsById: {}
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...state,
        [action.payload.boardId]: {
          ...defaultBoardState,
        }
      }
    case ADD:
      return state[action.payload.boardId] ? {
        ...state,
        labelsById: {
          ...state.labelsById,
          [action.payload.label.id]: {
            ...action.payload.label
          }
        },
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          labels: addUniqueValueToArray({
            array: state[action.payload.boardId].labels,
            value: action.payload.label.id,
            index: action.payload.label.index
          }),
        }
      } : state
    case ADD_ARRAY: {
      if (!state[action.payload.boardId]) return state

      const newState = {
        ...state,
        labelsById: { ...state.labelsById },
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          labels: [ ...state[action.payload.boardId].labels ],
        }
      }

      action.payload.array.forEach(label => {
        newState[action.payload.boardId].labels = addUniqueValueToArray({
          array: newState[action.payload.boardId].labels,
          value: label.id,
          index: label.index
        })
        newState.labelsById[label.id] = {
          ...label
        }
      })

      return newState
    }
    case REMOVE:
      return state[action.payload.boardId] ? {
        ...state,
        [action.payload.boardId]: {
          ...state[action.payload.boardId],
          labels: state[action.payload.boardId].labels.filter(id => id !== action.payload.labelId),
        }
      } : state
    case SET_NAME:
      return state.labelsById[action.payload.labelId] ? {
        ...state,
        labelsById: {
          ...state.labelsById,
          [action.payload.labelId]: {
            ...state.labelsById[action.payload.labelId],
            name: action.payload.name
          }
        }
      } : state
    case SET_COLOR:
      return state.labelsById[action.payload.labelId] ? {
        ...state,
        labelsById: {
          ...state.labelsById,
          [action.payload.labelId]: {
            ...state.labelsById[action.payload.labelId],
            color: action.payload.color
          }
        }
      } : state
    case SET_POSITION:
      return state.labelsById[action.payload.labelId] ? {
        ...state,
        labelsById: {
          ...state.labelsById,
          [action.payload.labelId]: {
            ...state.labelsById[action.payload.labelId],
            position: action.payload.position
          }
        }
      } : state
    default: return state
  }
}

export function add ({ boardId, label }) {
  return {
    type: ADD,
    payload: {
      boardId,
      label,
    }
  }
}

export function addArray ({ boardId, array }) {
  return {
    type: ADD_ARRAY,
    payload: {
      boardId,
      array
    }
  }
}

export function remove ({ boardId, labelId }) {
  return {
    type: REMOVE,
    payload: {
      boardId,
      labelId
    }
  }
}

export function setName ({ labelId, name }) {
  return {
    type: SET_NAME,
    payload: {
      labelId,
      name
    }
  }
}

export function setColor ({ labelId, color }) {
  return {
    type: SET_COLOR,
    payload: {
      labelId,
      color
    }
  }
}

export function setPosition ({ labelId, position }) {
  return {
    type: SET_POSITION,
    payload: {
      labelId,
      position
    }
  }
}
